import React from "react";
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
import { type PopupProps } from "./Popup";
import { SvgSaveProject, SvgWarning } from "components/svg";

export interface ConfirmationProjectPopupProps extends PopupProps {
  saveCallback: () => void;
  confirmCallBack?: () => void;
  closePopup?: () => void;
}

export const ConfirmationProjectPopup: React.FC<ConfirmationProjectPopupProps> = ({
  saveCallback,
  confirmCallBack,
  //closePopup
  //...rest
}) => {
  const { t, tHtml } = useTranslation();

  return (
    <Popup
      //noHeader 
      noHorizontalLine={true}
      fixSize="middle"
    //{...rest}
    >
      {({ onClose }) => {
        return (
          <group>
            <group
              data-space="5"
              data-direction="column"
            >
              <icon data-svg-size="48" data-svg-color="main" data-shrink="no"><SvgWarning /></icon>
            </group>
            <group
              data-direction="column"
              data-gap="20"
              data-space="10"
              data-space-horizontal="40"
              data-space-top="5"
              data-height="autofit"
            >
              <group data-gap="10" data-space-vertical="10">
                <group data-direction="column" data-gap="10" data-length="autofit"  >


                  <text
                    data-text-align="center" 
                    data-wrap="wrap"
                    data-text-size="13"
                    data-wrap-line="">
                    {tHtml('LEAVE_WARNING')}
                  </text>
                </group>
              </group>
            </group>
            
            <group
              data-space="30"
              data-space-top="10"
              data-gap="10"
              //data-background="highlight"
              //data-type="grid"
            >

              <group data-direction="row" data-position="bottom" data-gap="10">
                <group data-justify="center" data-gap="20"  data-length="autofit" data-fit="1">
                  <Button
                    
                    secondary
                    large
                    onClick={() => {
                      saveCallback?.();
                      onClose?.();
                    }}
                    icon={<icon data-svg-size="20" data-svg-color="white"><SvgSaveProject /></icon>}
                  >
                    {t('NAV_SAVE')}
                  </Button>
                  <Button
                    accent
                    secondary
                    large
                    onClick={() => {
                      confirmCallBack?.();
                      onClose?.();
                    }}
                  // onClick={handleSubmit(onSubmit)}
                  >
                    {t('CONFIRM')}
                  </Button>
                </group>
                <group data-justify="center" data-color="secondary">
                  <Button
                    large
                    onClick={() => {
                      onClose?.();
                    }}
                  // onClick={handleSubmit(onSubmit)}
                  >
                    {t('CANCEL')}
                  </Button>
                </group>
              </group>
            </group>


          </group>
        );
      }}
    </Popup>
  );
};
